// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body[data-form-style=minimal] input[type=text]{border:none;background-color:#fff;padding:5px 10px}.p-checkbox{align-items:center}body[data-form-submit=regular] button[type=submit]{background-color:var(--123-green)}body[data-button-style*=slightly_rounded] button[type=submit]{border-radius:10px}.p-autocomplete-input{max-width:100%}", ""]);
// Exports
module.exports = exports;
